// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5577fed7","455":"1a7e7bd6","488":"3406a2de","977":"4765533d"}[chunkId] + ".chunk.js";
};